import 'core-js/stable/promise/all-settled'
import 'regenerator-runtime/runtime'
import {
  allowTracking,
  getScriptUrl,
  loadLocale,
  parseQueryParameters,
  setCookie
} from './helpers'
import {
  appendBanner,
  appendStyles,
  closeBanner
} from './helpers/uiHelpers'
import './scss/main.scss'

(async () => {
  const bannerFileName = BANNER_FILE_NAME
  const { baseUrl, query } = getScriptUrl(bannerFileName)
  const queryParams = parseQueryParameters(query)
  const cssQuery = queryParams.v ? `?v=${queryParams.v}` : ''

  // Load styles first
  appendStyles(`${baseUrl}/${bannerFileName}.css${cssQuery}`)

  const defaultLocale = 'en_US'
  const defaultContainerId = 'gdprBanner'
  const defaultCookieUrl = '/p/support/cookies'

  const containerId = queryParams.containerId || defaultContainerId
  const locale = queryParams.locale || defaultLocale
  const cookieUrl = queryParams.cookieUrl || defaultCookieUrl

  const [localeText, defaultLocaleText] = await Promise.all([
    loadLocale(locale, baseUrl),
    loadLocale(defaultLocale, baseUrl)
  ])

  if (localeText === null || defaultLocaleText === null) {
    throw Error('Something is wrong with locale.')
  }

  const {
    accept,
    link,
    headline,
    text,
  } = localeText || {}

  const {
    accept: defaultAccept,
    link: defaultLink,
    headline: defaultHeadline,
    text: defaultText,
  } = defaultLocale || {}

  const banner = appendBanner(
    containerId,
    headline || defaultHeadline || '',
    text || defaultText || '',
    link || defaultLink || '',
    accept || defaultAccept || '',
    cookieUrl
  )

  if (!banner) {
    throw Error('Could not create GDPR banner')
  }

  const button = banner.getElementsByClassName('gdpr-banner-btn')[0] || null
  if (!button) {
    throw Error('The accept button does not exist')
  }

  button.addEventListener('click', () => {
    setCookie('OIP', 1)
    allowTracking()
    closeBanner(banner)

    // Trigger event
    const event = document.createEvent('Event')
    event.initEvent('gdprAccepted', true, true)
    window.dispatchEvent(event)
  })
})()
